(() => {
  if (document.body?.dataset.fdTemplate !== 'collection') return;
  const labels = JSON.parse(document.getElementById('fd-navigation-labels')?.textContent || '{}');
  const allLabel = document.querySelector('.fdh3-chip--all .nm')?.textContent.trim() || (document.documentElement.lang.startsWith('fr') ? 'Tous' : 'All');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const rails = new Map(), hinted = new Set(), observers = new Map();
  const flags = new Set('al ar at au ba be bo br ca cd cg ch ci cl cm cn co cr cv cw cz de dk dz ec eg es fi fr gb-eng gb-nir gb-sct gb-wls ge gh gr gt hn hr ht hu ie iq ir it jm jo jp kr ma ml mx ng nl no nz om pa pe pl ps pt py qa ro rs sa se si sk sn sv tn tr ua us uy uz ve za'.split(' '));
  let frame = 0, sequence = 0;
  // Restore directory choices as filters of the current catalogue, not page exits.
  const catalogue = location.pathname.match(/^\/collections\/([^/]+)/)?.[1];
  const catalogueKinds = new Set(['maillots-clubs', 'selections-nationales', 'maillots-retro', 'editions-speciales', 'maillots-2026-2027', 'tout-le-catalogue']);
  if (catalogueKinds.has(catalogue)) {
    document.querySelectorAll('.fdpn-row[href]').forEach(link => {
      const path = new URL(link.href).pathname.split('/').filter(Boolean);
      if (path[0] === 'collections' && path[1]) link.setAttribute('href', '/collections/' + catalogue + '/' + (path[2] || path[1]));
    });
  }
  document.querySelectorAll('#fdpn-pays,#fdpn-clubs').forEach(panel => {
    let trigger = null, wasOpen = false;
    const title = panel.querySelector('.fdpn-head b');
    if (title) { title.id ||= panel.id + '-title'; panel.setAttribute('aria-labelledby', title.id); }
    panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
    function syncDialog() {
      const open = panel.classList.contains('on');
      const search = panel.querySelector('.fdpn-search');
      if (search && !panel.querySelector('[data-fd-clear-family]')) {
        const all = document.createElement('button');all.type = 'button';all.className = 'fd-directory-all';
        all.dataset.fdClearFamily = panel.id.replace('fdpn-', '');all.textContent = allLabel;
        const selected = document.querySelector('.fdh3-row[data-fd-entities="'+all.dataset.fdClearFamily+'"] .fdh3-chip.on:not(.fdh3-chip--all)');
        all.setAttribute('aria-pressed', String(!selected));all.classList.toggle('on', !selected);search.after(all);
      }
      panel.setAttribute('aria-hidden', String(!open));
      document.querySelectorAll('[data-fdpn="' + panel.id.replace('fdpn-', '') + '"]').forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (open && !wasOpen) panel.querySelector('.fdpn-head button[data-fdpn-close]')?.focus({preventScroll: true});
      if (!open && wasOpen && panel.contains(document.activeElement)) trigger?.focus({preventScroll: true});
      wasOpen = open;
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-fdpn]');
      if (button && 'fdpn-' + button.dataset.fdpn === panel.id) trigger = button;
    }, true);
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault(); panel.classList.remove('on'); document.documentElement.style.overflow = ''; syncDialog();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('button,input,a[href],[tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    new MutationObserver(syncDialog).observe(panel, {attributes: true, attributeFilter: ['class']});
    syncDialog();
  });
  function upgradeFlags(root) {
    root.querySelectorAll('.fdh3-row[data-fd-entities="pays"] img,#fdpn-pays img,#fdpn-clubs img').forEach(image => {
      if (image.dataset.fdHdFlag) return;
      const match = image.src.match(/\/fd-flag-([a-z-]+)\.(?:webp|svg)(?:\?|$)/);
      if (!match || !flags.has(match[1])) return;
      const original = image.src, copy = image.cloneNode(true);
      copy.dataset.fdHdFlag = match[1];
      copy.classList.add('fd-country-flag');
      copy.decoding = 'async'; copy.loading = 'lazy';
      copy.removeAttribute('srcset');
      copy.src = new URL('fd-catalogue-hd-' + match[1] + '-20260920.webp', original).href;
      copy.addEventListener('error', () => { copy.src = original; }, {once: true});
      image.replaceWith(copy);
    });
  }
  function stopHint(state, interacted = true) {
    clearTimeout(state.timer); cancelAnimationFrame(state.animation);
    state.animation = 0; state.row.classList.remove('is-hinting');
    if (interacted) { state.interacted = true; hinted.add(state.kind); }
  }
  function update(state) {
    const max = Math.max(0, state.row.scrollWidth - state.row.clientWidth);
    const left = Math.max(0, state.row.scrollLeft);
    state.next.hidden = max < 2 || left >= max - 3;
    state.previous.hidden = max < 2 || left <= 3;
    state.host.classList.toggle('has-next', !state.next.hidden);
    state.host.classList.toggle('has-previous', !state.previous.hidden);
  }
  function hint(state) {
    if (reduced.matches || state.interacted || hinted.has(state.kind) || !state.row.isConnected) return;
    const box = state.row.getBoundingClientRect();
    const max = state.row.scrollWidth - state.row.clientWidth;
    if (box.top < 0 || box.bottom > innerHeight || max < 24) return;
    const origin = state.row.scrollLeft, distance = Math.min(36, max - origin);
    if (distance < 12) return;
    hinted.add(state.kind); state.row.classList.add('is-hinting');
    let start;
    const tick = time => {
      if (state.interacted || !state.row.isConnected || reduced.matches) { stopHint(state, false); return; }
      start ??= time;
      const progress = Math.min(1, (time - start) / 1100);
      state.row.scrollLeft = origin + distance * (1 - Math.cos(progress * Math.PI * 2)) / 2;
      if (progress < 1) state.animation = requestAnimationFrame(tick);
      else { state.row.scrollLeft = origin; stopHint(state, false); update(state); }
    };
    state.animation = requestAnimationFrame(tick);
  }
  const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = rails.get(entry.target); if (!state) return;
      clearTimeout(state.timer);
      if (entry.isIntersecting && entry.intersectionRatio >= .95) state.timer = setTimeout(() => hint(state), 850);
      else stopHint(state, false);
    });
  }, {threshold: [0, .95, 1]}) : null;
  const resize = 'ResizeObserver' in window ? new ResizeObserver(entries => {
    entries.forEach(entry => { const state = rails.get(entry.target); if (state) update(state); });
  }) : null;
  function mount(row) {
    const oldAll = row.querySelector('a.fdh3-chip--all');
    if (oldAll) {
      const directory = document.createElement('button');directory.type = 'button';directory.className = 'fdh3-chip fdh3-chip--all fd-rail-directory';
      directory.dataset.fdpn = row.dataset.fdEntities;directory.dataset.fdCompleteLabel = 'true';
      directory.innerHTML = oldAll.innerHTML;
      const text = row.dataset.fdEntities === 'pays' ? labels.catalogueCountries : labels.catalogueClubs;
      directory.querySelector('.nm').textContent = text;directory.setAttribute('aria-label', text);
      directory.setAttribute('aria-haspopup', 'dialog');directory.setAttribute('aria-controls', 'fdpn-' + row.dataset.fdEntities);
      directory.setAttribute('aria-expanded', 'false');oldAll.replaceWith(directory);
    }
    if (rails.has(row)) { update(rails.get(row)); return; }
    const kind = row.dataset.fdEntities;
    const heading = row.previousElementSibling;
    const host = document.createElement('div'); host.className = 'fd-catalogue-rail';
    row.before(host); host.append(row);
    row.id ||= 'fd-team-rail-' + (++sequence);
    row.setAttribute('role', 'region');
    row.setAttribute('aria-label', heading?.querySelector('h4')?.textContent || (kind === 'pays' ? labels.catalogueCountries : labels.catalogueClubs));
    row.tabIndex = 0;
    function button(direction) {
      const result = document.createElement('button'); result.type = 'button';
      result.className = 'fd-rail-arrow fd-rail-arrow--' + direction;
      result.setAttribute('aria-controls', row.id);
      result.setAttribute('aria-label', direction === 'next' ? labels.nextTeams : labels.previousTeams);
      result.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';
      host.append(result); return result;
    }
    const state = {row, host, kind, next: button('next'), previous: button('previous'), timer: 0, animation: 0, interacted: false};
    rails.set(row, state);
    function move(direction) {
      stopHint(state);
      row.scrollBy({left: direction * Math.max(70, row.clientWidth * .7), behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    state.next.addEventListener('click', () => move(1));
    state.previous.addEventListener('click', () => move(-1));
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(event => host.addEventListener(event, () => stopHint(state), {passive: true}));
    row.addEventListener('scroll', () => update(state), {passive: true});
    row.addEventListener('keydown', event => {
      stopHint(state);
      if (event.target !== row || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    update(state); resize?.observe(row); visibility?.observe(row);
  }
  const docks = new Map();
  let dockFrame = 0, followUntil = 0;
  let lastScroll = scrollY, downTravel = 0, upTravel = 0, keepVisibleUntil = 0;
  const header = document.querySelector('.header-section');
  function setDockValue(node, key, value) { if (node.style.getPropertyValue(key) !== value) node.style.setProperty(key, value); }
  function releaseDock(state) {
    state.node.classList.remove('fd-catalogue-pinned');
    state.space.hidden = true;
    state.pinned = false;
  }
  function updateDocks(time) {
    dockFrame = 0;
    const headerBox = header?.getBoundingClientRect();
    let top = headerBox ? Math.max(0, Math.min(headerBox.height, headerBox.bottom)) : 0;
    if (top > 0) header.querySelectorAll('.fd-header-search').forEach(extension => {
      const style = getComputedStyle(extension);
      if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > .01)
        top = Math.max(top, extension.getBoundingClientRect().bottom);
    });
    const start = top;
    const ordered = [...docks.values()].filter(state => state.node.isConnected).sort((a, b) =>
      a.node.compareDocumentPosition(b.node) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
    ordered.forEach(state => {
      const {node, space} = state;
      const box = (state.pinned ? space : node).getBoundingClientRect();
      if (!box.width || box.top > top + .5) {
        if (state.pinned) releaseDock(state);
        return;
      }
      if (!state.pinned) {
        const style = getComputedStyle(node);
        setDockValue(node, '--fd-dock-inset-left', Math.max(0, box.left) + 'px');
        setDockValue(node, '--fd-dock-inset-right', Math.max(0, document.documentElement.clientWidth - box.right) + 'px');
        space.style.height = box.height + 'px';
        space.style.marginTop = style.marginTop;
        space.style.marginBottom = style.marginBottom;
        space.hidden = false;
        node.classList.add('fd-catalogue-pinned');
        state.pinned = true;
        const row = node.querySelector('.fdh3-row');
        if (row && rails.has(row)) stopHint(rails.get(row), false);
      }
      setDockValue(node, '--fd-dock-top', top + 'px');
      top += node.getBoundingClientRect().height;
    });
    setDockValue(document.documentElement, '--fd-catalogue-dock-bottom', top + 'px');
    document.documentElement.classList.toggle('fd-catalogue-docked', top > start);
    if (time < followUntil) dockFrame = requestAnimationFrame(updateDocks);
  }
  function scheduleDocks(follow = false) {
    if (follow) followUntil = performance.now() + 750;
    if (!dockFrame) dockFrame = requestAnimationFrame(updateDocks);
  }
  const dockResize = new ResizeObserver(() => scheduleDocks());
  function syncDocks() {
    docks.forEach((state, node) => {
      if (node.isConnected) return;
      state.space.remove(); dockResize.unobserve(node); docks.delete(node);
    });
    document.querySelectorAll('.fd-catalogue-rail,.fdc-bar').forEach(node => {
      if (docks.has(node)) return;
      const space = document.createElement('div');
      space.className = 'fd-catalogue-dock-space'; space.hidden = true;
      space.setAttribute('aria-hidden', 'true');
      if (node.matches('.fdc-bar')) node.before(space); else node.after(space);
      node.classList.add('fd-catalogue-dock-item');
      docks.set(node, {node, space, pinned: false}); dockResize.observe(node);
    });
    scheduleDocks();
  }
  if (header) {
    new MutationObserver(() => scheduleDocks(true)).observe(header, {attributes: true, subtree: true, attributeFilter: ['class', 'style', 'data-open', 'aria-hidden']});
    dockResize.observe(header);
    header.addEventListener('transitionrun', () => scheduleDocks(true));
  }
  addEventListener('scroll', () => {
    const delta = scrollY - lastScroll; lastScroll = scrollY;
    if (delta > 0) { downTravel += delta; upTravel = 0; }
    else if (delta < 0) { upTravel -= delta; downTravel = 0; }
    if (upTravel > 8 || scrollY < 300 || performance.now() < keepVisibleUntil) document.documentElement.classList.remove('fd-catalogue-descending');
    else if (downTravel > 110) document.documentElement.classList.add('fd-catalogue-descending');
    scheduleDocks();
  }, {passive: true});
  document.addEventListener('fd:results-focus', () => {keepVisibleUntil = performance.now() + 1800;downTravel = 0;document.documentElement.classList.remove('fd-catalogue-descending');scheduleDocks(true);});
  addEventListener('resize', () => { docks.forEach(releaseDock); scheduleDocks(true); }, {passive: true});
  addEventListener('pageshow', () => scheduleDocks(true));
  function scan() {
    frame = 0;
    const season = document.querySelector('[data-fdc-sort] option[value="season"]');
    if (season && labels.seasonRecent && season.textContent !== labels.seasonRecent) season.textContent = labels.seasonRecent;
    rails.forEach((state, row) => {
      if (row.isConnected) return;
      stopHint(state, false); resize?.unobserve(row); visibility?.unobserve(row); rails.delete(row);
    });
    upgradeFlags(document);
    document.querySelectorAll('.fdh3-row[data-fd-entities]').forEach(mount);
    syncDocks();
    document.querySelectorAll('.fdh3,#fdpn-pays,#fdpn-clubs').forEach(root => {
      if (observers.has(root)) return;
      const observer = new MutationObserver(schedule);
      observer.observe(root, {childList: true, subtree: true}); observers.set(root, observer);
    });
    observers.forEach((observer, root) => { if (!root.isConnected) { observer.disconnect(); observers.delete(root); } });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(scan); }
  reduced.addEventListener('change', () => { if (reduced.matches) rails.forEach(state => stopHint(state, false)); });
  document.addEventListener('fd:category-changed', schedule);
  document.addEventListener('fd:directory-ready', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
})();

